import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
	apiKey: "AIzaSyDg0UJ8OBEfcnwhp0ZuF05kMfelmON0IRo",
	authDomain: "urban59-d7233.firebaseapp.com",
	projectId: "urban59-d7233",
	storageBucket: "urban59-d7233.firebasestorage.app",
	messagingSenderId: "86931166677",
	appId: "1:86931166677:web:8455d56dfd1d425136595c",
	measurementId: "G-JGZNERJDBT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Secondary app instance used exclusively for creating new users.
// createUserWithEmailAndPassword() automatically signs in as the new user,
// which would kick the trainer out of their session. Using a separate app
// instance isolates that side-effect so the trainer stays logged in.
const secondaryApp = initializeApp(firebaseConfig, "secondaryApp");
export const secondaryAuth = getAuth(secondaryApp);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

export default app;
